<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a :href="'/#/'">
            <i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item">
          <a v-if="['training material', 'manual'].includes(folderName)" :href="'/#/staticfolderlist/'+this.folderName">{{this.folderName}}</a>
          <a v-else :href="'/#/d1folderlist/'+this.folderName">{{this.folderName}}</a>
        </li>
        <li class="breadcrumb-item">
          <a :href="'/#/d2folderlist/'+this.folderName+'/'+this.dynamicFolder">{{this.dynamicFolder}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{this.selectFolder}}</li>
      </ol>
    </nav>
    <div class="card">
      <div class="card-header">
        <div class="card-title">{{this.selectFolder}}</div>
      </div>
      <div class="card-body">
        <ul class="list-news">
          <li v-for="(folder,index) in folders.slice(startFiles,endFiles)" v-bind:key="index" >
            <!-- 檔案類 -->
            <a v-if="folder.file" v-bind:href="folder.webUrl" target="_blank">
              <div class="icon">
								<span class="fa-stack">
                  <i v-bind:class="getFileIcon(folder.name)">{{folder.name.split('.')[folder.name.split('.').length - 1].toUpperCase()}}</i>
                  <i class="fa fa-file-o fa-stack-1x"></i>
								</span>
							</div>
              <div class="con">
                <div class="title">{{folder.name}}</div>
                <div class="text">{{$moment(folder.createdDateTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
              </div>
            </a>
            <a v-else v-bind:href="`/#/d3folderdetail/${encodeURIComponent(folderName)}/${encodeURIComponent(dynamicFolder)}/${encodeURIComponent(selectFolder)}/${encodeURIComponent(folder.name)}`">
              <div class="icon">
								<span class="fa-stack">
									<i class="fa fa-folder fa-stack-1x"></i>
								</span>
							</div>
              <div class="con">
                <div class="title">{{folder.name}}</div>
                <div class="text">{{$moment(folder.createdDateTime).format("YYYY-MM-DD HH:mm:ss") }}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="card-footer">
        <div class="func-tool">
          <div class="pagination-num">
            {{currenPage}}/{{getTotalPage}}
            <span>Total:{{total}}</span>
          </div>
          <ul class="pagination justify-content-center">
            <li class="page-item">
              <a class="page-link" v-on:click="getLastPage(currenPage)">
                <i class="fa fa-angle-left"></i>
              </a>
            </li>
            <li class="page-item" v-for="(page,index) in getTotalPage" v-bind:key="index">
              <a class="page-link"  v-on:click="getPagination(index)">{{index+1}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" v-on:click="getNextPage(currenPage)">
                <i class="fa fa-angle-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FolderList',
  data: () => ({
    startFiles: 0,
    endFiles: 15,
    numberPerPage: 15,
    currenPage: 1,
    total: 0,
    folderName: '',
    dynamicFolder: '',
    selectFolder: '',
    folders: []
  }),
  created () {
    this.folderName = this.$route.params.name
    this.dynamicFolder = this.$route.params.category
    this.selectFolder = this.$route.params.select
    this.getPilotD3Folder(localStorage.getItem('access_token'), this.folderName, this.dynamicFolder, this.selectFolder)
      .then(resp => {
        this.folders = resp.data.value
        console.log('folder', this.folders)
        this.total = resp.data.value.length
      })
      .catch(err => {
        console.log('err', err)
      })
  },
  methods: {
    getUrl (newsobj) {
      if (newsobj.fields.Thumbnail === undefined) {
        return 'img/bg_file.jpg'
      } else {
        return newsobj.fields.Thumbnail.Url
      }
    },
    getFileIcon (filename) {
      var temp = filename.split('.')[filename.split('.').length - 1].toLowerCase()
      switch (temp) {
        case 'pptx':case 'ppt':
          return 'fa fa-stack-1x text-xs bg-dark'
        case 'pdf':
          return 'fa fa-stack-1x text-xs bg-danger'
        case 'jpg':case 'jpeg':case 'png':case 'gif':
          return 'fa fa-stack-1x text-xs bg-success'
        case 'mp4':case 'wmv':case 'mov':
          return 'fa fa-stack-1x text-xs'
        default:
          return 'fa fa-stack-1x text-xs d-none'
      }
    },
    getPagination (page) {
      this.currenPage = page + 1
      this.startFiles = page * this.numberPerPage
      this.endFiles = (page + 1) * this.numberPerPage
    },
    getLastPage (page) {
      if (page > 1) {
        this.currenPage = page - 1
        this.startFiles = (page - 2) * this.numberPerPage + 1
        this.endFiles = (page - 1) * this.numberPerPage
      }
    },
    getNextPage (page) {
      if (page < this.getTotalPage) {
        this.currenPage = page + 1
        this.startFiles = page * this.numberPerPage
        this.endFiles = (page + 1) * this.numberPerPage
      }
    }
  },
  computed: {
    getTotalPage () {
      return Math.ceil(this.folders.length / this.numberPerPage) ? Math.ceil(this.folders.length / this.numberPerPage) : 1
    }
  }
}
</script>
